import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Card, CardContent } from "@/components/ui/card";
import { Apple, Sparkles, Loader2 } from "lucide-react";
import { motion } from "framer-motion";
import { API, useAuth } from "@/App";

const BabyUpdateCard = () => {
  const { token } = useAuth();
  const { i18n } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  useEffect(() => {
    const lang = (i18n.language || "en").split("-")[0];
    axios.get(`${API}/wellness/pregnancy/week`, { headers, withCredentials: true, params: { lang } })
      .then(res => setData(res.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, i18n.language]);

  if (loading) {
    return (
      <Card className="glass">
        <CardContent className="py-6 text-center">
          <Loader2 className="w-5 h-5 animate-spin text-mystic-300 mx-auto" />
        </CardContent>
      </Card>
    );
  }
  if (!data) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.22 }}
      data-testid="baby-update-card"
    >
      <Card className="glass border-pink-400/30 bg-gradient-to-br from-pink-500/10 via-purple-500/5 to-transparent">
        <CardContent className="p-5">
          <div className="flex items-start gap-4">
            <div className="text-5xl" aria-hidden="true">{data.size_emoji || "🌱"}</div>
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <p className="text-pink-200 text-xs uppercase tracking-wider flex items-center gap-1">
                  <Sparkles className="w-3 h-3" /> Baby Update — Week {data.week}
                </p>
              </div>
              <p className="text-white text-base font-medium mb-2" data-testid="baby-size-text">
                Your baby is about the size of a <span className="text-pink-300">{data.size}</span>
              </p>
              <p className="text-mystic-100 text-sm leading-relaxed mb-2" data-testid="baby-highlight">
                {data.highlight}
              </p>
              <div className="flex items-start gap-1.5 mt-2">
                <Apple className="w-4 h-4 text-pink-300 flex-shrink-0 mt-0.5" />
                <p className="text-mystic-200/80 text-xs leading-relaxed" data-testid="baby-tip">
                  <span className="text-pink-200 font-medium">This week's tip: </span>
                  {data.tip}
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default BabyUpdateCard;
